import { render } from "./CuratedProducts.vue?vue&type=template&id=22b218b1"
import script from "./CuratedProducts.vue?vue&type=script&lang=js"
export * from "./CuratedProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__